var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"file-uploader",attrs:{"action":"","accept":_vm.finalAccept,"limit":_vm.limit,"show-file-list":false,"multiple":true,"before-upload":_vm.beforeUpload,"on-exceed":_vm.handleExceed,"disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }